(function () {
  const initHlSlider = (section) => {
    const sliderEl = section.querySelector(".highlights-slider");
    if (!sliderEl) return;

    const productsPerRow = Number(sliderEl.dataset.productsPerRow || 6);
    const productsPerRowMobile = Number(
      sliderEl.dataset.productsPerRowMobile || 1
    );

    const nextBtn = section.querySelector(
      ".heading-group__navigation-button-next"
    );
    const prevBtn = section.querySelector(
      ".heading-group__navigation-button-prev"
    );

    const paginationElement = section.querySelector(
      ".heading-group__pagination"
    );
    const slidesPerViewMobile = productsPerRowMobile + 0.11;
    const slidesPerView576 = productsPerRow > 1 ? 2 : 1;
    const slidesPerView990 =
      productsPerRow > 2 ? slidesPerView576 + 1 : slidesPerView576;
    const slidesPerView1100 = productsPerRow >= 4 ? 4 : productsPerRow;
    const slidesPerView1360 = productsPerRow;

    const sliderSettings = {
      slidesPerView: slidesPerViewMobile,
      slidesPerGroup: Math.max(1, productsPerRowMobile),
      spaceBetween: 4,
      loop: true,
      speed: 800,
      watchSlideProgress: true,
      centeredSlides: true,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      pagination: {
        el: paginationElement,
        type: "fraction",
        clickable: true,
      },
      breakpoints: {
        576: {
          slidesPerView: slidesPerView576,
          slidesPerGroup: slidesPerView576,
          centeredSlides: false,
          loop: false,
        },
        990: {
          slidesPerView: slidesPerView990,
          slidesPerGroup: slidesPerView990,
          centeredSlides: false,
          loop: false,
        },
        1100: {
          slidesPerView: slidesPerView1100,
          slidesPerGroup: slidesPerView1100,
          centeredSlides: false,
          loop: false,
        },
        1360: {
          slidesPerView: slidesPerView1360,
          slidesPerGroup: slidesPerView1360,
          centeredSlides: false,
          loop: false,
        },
      },
    };

    new Swiper(sliderEl, sliderSettings);
  };

  const destroySlider = (section) => {
    const sliderEl = section.querySelector(".highlights-slider");
    if (!sliderEl) return;

    if (sliderEl.swiper) sliderEl.swiper.destroy();
    sliderEl.querySelector(".swiper-wrapper")?.removeAttribute("style");
    sliderEl.querySelectorAll(".swiper-slide").forEach((slide) => {
      slide.removeAttribute("style");
    });
  };

  const initSectionLayout = (section) => {
    if (!section || !section?.classList.contains("highlights-section")) {
      return;
    }

    const box = section.querySelector(".highlights");
    if (!box) return;

    const layout = box.dataset.layout || "grid";
    if (layout === "slider") {
      initHlSlider(box);
    } else {
      destroySlider(box);
    }

    const animateProductCard = (section) => {
      const SLIDE_SELECTOR = ".highlights__item";
      const CARD_SELECTOR = ".card-horizontal-wrapper";

      function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
      }

      function initFloatingProductCards() {
        const slides = section.querySelectorAll(SLIDE_SELECTOR);
        if (!slides.length) return;

        slides.forEach((slide) => {
          const card = slide.querySelector(CARD_SELECTOR);
          if (!card) return;

          let rafId = null;
          let pointerX = 0;
          let pointerY = 0;
          let isVisible = false;

          const offsetX = 20;
          const offsetY = 20;

          const setCardPosition = (clientX, clientY) => {
            const slideRect = slide.getBoundingClientRect();
            const cardRect = card.getBoundingClientRect();

            // Base position (cursor + offset)
            let x = clientX - slideRect.left + offsetX;
            let y = clientY - slideRect.top + offsetY;

            // Limits (keep inside slide)
            const minX = 0;
            const minY = 0;
            const maxX = slideRect.width - cardRect.width;
            const maxY = slideRect.height - cardRect.height;

            // Clamp inside bounds
            x = clamp(x, minX, maxX);
            y = clamp(y, minY, maxY);

            card.style.left = `${x}px`;
            card.style.top = `${y}px`;
          };

          const updatePosition = () => {
            rafId = null;
            if (!isVisible) return;
            setCardPosition(pointerX, pointerY);
          };

          const handlePointerMove = (event) => {
            pointerX = event.clientX;
            pointerY = event.clientY;

            if (rafId == null) {
              rafId = requestAnimationFrame(updatePosition);
            }
          };

          const showCard = (event) => {
            pointerX = event.clientX;
            pointerY = event.clientY;
            isVisible = true;

            card.classList.remove("is-following");
            setCardPosition(pointerX, pointerY);
            card.style.opacity = "1";

            requestAnimationFrame(() => {
              if (isVisible) {
                card.classList.add("is-following");
              }
            });
          };

          const hideCard = () => {
            isVisible = false;
            card.style.opacity = "0";
            card.classList.remove("is-following");

            if (rafId != null) {
              cancelAnimationFrame(rafId);
              rafId = null;
            }
          };

          slide.addEventListener("pointerenter", showCard);
          slide.addEventListener("pointermove", handlePointerMove);
          slide.addEventListener("pointerleave", hideCard);

          window.addEventListener("resize", () => {
            if (isVisible) {
              setCardPosition(pointerX, pointerY);
            }
          });
        });
      }

      initFloatingProductCards();
    };

    animateProductCard(section);
  };

  initSectionLayout(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSectionLayout(event.target);
  });
})();
